import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { Hero } from '@/sections/Hero';
import { GridPreview } from '@/sections/GridPreview';
import { Programme } from '@/sections/Programme';
import { Features } from '@/sections/Features';
import { Tracks } from '@/sections/Tracks';
import { TierTable } from '@/sections/TierTable';
import { CoachPreview } from '@/sections/CoachPreview';
import { Testimonials } from '@/sections/Testimonials';
import { Pricing } from '@/sections/Pricing';
import { Faq } from '@/sections/Faq';
import { FinalCta } from '@/sections/FinalCta';
import { CrmDoor } from '@/sections/CrmDoor';
import { CrmLanding } from '@/sections/crm/CrmLanding';
import { useWorkoutLog } from '@/lib/useWorkoutLog';
import { AppRouter } from '@/app/AppRouter';
import { useRoute } from '@/app/router';

/**
 * Lift2Fit web entry.
 *
 * `/` renders the marketing landing page (section order per
 * docs/ui-ux/ui-ux-spec.md §3.2); `/for-coaches` renders the CRM marketing page
 * for coaches and gyms; every other route is handed to the signed-in
 * application in `src/app`. The Grid's state lives here so the hero, the grid and
 * the footer all read the same session.
 *
 * The two audiences are deliberately separate pages: the lifter page only
 * carries a small "For coaches & gyms" door out, and the CRM page carries none
 * of the lifter proposition or lifter pricing (platform plan §3).
 */
const CRM_PATH = '/for-coaches';

export default function App() {
  const path = useRoute();

  if (path === CRM_PATH) return <CrmLanding />;

  return <LifterLanding />;
}

function LifterLanding() {
  const log = useWorkoutLog();

  return (
    <div className="min-h-screen bg-page">
      {/* The signed-in application (dashboard, roster, planner, profile) takes
          over on its own routes and renders nothing on the landing path. */}
      <AppRouter />

      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:border focus:border-accent focus:bg-surface focus:px-4 focus:py-2 focus:text-[13px] focus:font-bold focus:uppercase focus:tracking-[0.08em] focus:text-ink"
      >
        Skip to content
      </a>

      <Header />

      <main id="main">
        <Hero />
        <GridPreview api={log} />
        <Programme />
        <Features />
        <Tracks />
        <TierTable />
        <CoachPreview />
        <Testimonials />
        <Pricing />
        <Faq />
        <FinalCta />
        {/* The one door from the lifter page to the CRM — small, factual, and
            free of CRM pricing so the lifter page stays a lifter page. */}
        <CrmDoor />
      </main>

      <Footer />
    </div>
  );
}
